import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const ProductReport = () => {
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    saleUnitId: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    startTime: "",
    endDate: "",
    endTime: "",
    productCode: "",
    productTitle: "",
    paymentType: 0,
    orderType: 0,
    invoiceItemType: 0,
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [gridSumData, setGridSumData] = useState({
    sumOfAmount: 0,
    sumOfDiscount: 0,
    sumOfTax: 0,
    sumOfFinalPrice: 0,
  });
  const [saleUnits, setSaleUnits] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [invoiceItemTypes, setInvoiceItemTypes] = useState([]);

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp1)) setSaleUnits(resp1.data);

    const resp2 = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(resp2)) setOrderTypes(resp2.data);

    const resp3 = await apiMethod.getPaymentTypes();
    if (methods.showApiErrors(resp3)) setPaymentTypes(resp3.data);

    const resp4 = await apiMethod.getInvoiceItemTypes();
    if (methods.showApiErrors(resp4)) setInvoiceItemTypes(resp4.data);
  };

  const downloadExcelFile = async () => {
    setLoading(true);
    const resp = await apiMethod.getSalesProductExcel(filterModel);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);

    window.location = process.env.REACT_APP_ROOT_SALE_API + "/" + resp.data;
  };

  const getGridData = async () => {
    const resp = await apiMethod.getSalesProductReport(filterModel);
    if (!methods.showApiErrors(resp)) return false;

    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    setFilterModel({ ...filterModel });
    setGridData(resp.data);

    gridSumData.sumOfAmount = resp.sumOfAmount;
    gridSumData.sumOfDiscount = resp.sumOfDiscount;
    gridSumData.sumOfTax = resp.sumOfTax;
    gridSumData.sumOfFinalPrice = resp.sumOfFinalPrice;
    setGridSumData({ ...gridSumData });
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.saleUnitId = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.startTime = "";
    filterModel.endDate = "";
    filterModel.endTime = "";
    filterModel.productCode = "";
    filterModel.productTitle = "";
    filterModel.paymentType = 0;
    filterModel.orderType = 0;
    filterModel.invoiceItemType = 0;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
    setResetKey((prev) => prev + 1);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const moduleRender = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/reports/home`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                گزارش تفکیکی کالا
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>گزارش تفکیکی کالا</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-2">
                    <label htmlFor="ddlStatuses" className="form-label">
                      بخش های فروش
                    </label>
                    <select
                      id="ddlStatuses"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.saleUnitId}
                      onChange={(e) => {
                        filterModel.saleUnitId = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه بخش ها</option>
                      {saleUnits.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlOrderType" className="form-label">
                      نوع سفارش
                    </label>
                    <select
                      id="ddlOrderType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.orderType}
                      onChange={(e) => {
                        filterModel.orderType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {orderTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlPaymentType" className="form-label">
                      نوع پرداخت
                    </label>
                    <select
                      id="ddlPaymentType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.paymentType}
                      onChange={(e) => {
                        filterModel.paymentType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {paymentTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlItemType" className="form-label">
                      نوع قلم کالا
                    </label>
                    <select
                      id="ddlItemType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.invoiceItemType}
                      onChange={(e) => {
                        filterModel.invoiceItemType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {invoiceItemTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="productTitle" className="form-label">
                      عنوان کالا
                    </label>
                    <input
                      id="productTitle"
                      className="form-control"
                      type="text"
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.productTitle}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          productTitle: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-2">
                    <label htmlFor="productCode" className="form-label">
                      کد کالا
                    </label>
                    <input
                      id="productCode"
                      className="form-control"
                      type="text"
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.productCode}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          productCode: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startDate" className="form-label">
                      از تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.startDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.startDate = value.format("YYYY/MM/DD");
                        else filterModel.startDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startTime" className="form-label">
                      از ساعت
                    </label>
                    <DatePicker
                      key={`startTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker
                          hideSeconds
                          value={filterModel.startTime}
                        />,
                      ]}
                      onChange={(value) => {
                        if (value)
                          filterModel.startTime = value.format("HH:mm");
                        else filterModel.startTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="enddate" className="form-label">
                      تا تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.endDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.endDate = value.format("YYYY/MM/DD");
                        else filterModel.endDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="endTime" className="form-label">
                      تا ساعت
                    </label>
                    <DatePicker
                      key={`endTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker hideSeconds value={filterModel.endTime} />,
                      ]}
                      onChange={(value) => {
                        if (value) filterModel.endTime = value.format("HH:mm");
                        else filterModel.endTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
                <div className="mt-3 text-center">
                  <div className="">
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info me-1"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      onClick={() => {
                        downloadExcelFile();
                      }}
                    >
                      <i className="bi bi-file-earmark-excel"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <div className="card mb-3 mt-2">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-3">
                        مجموع تعداد: {gridSumData.sumOfAmount}
                      </div>
                      <div className="col-3">
                        مجموع تخفیف:{" "}
                        {methods.addNumSeperator(gridSumData.sumOfDiscount)}
                      </div>
                      <div className="col-3">
                        مجموع مالیات:{" "}
                        {methods.addNumSeperator(gridSumData.sumOfTax)}
                      </div>
                      <div className="col-3">
                        مجموع فروش:{" "}
                        {methods.addNumSeperator(gridSumData.sumOfFinalPrice)}
                      </div>
                    </div>
                  </div>
                </div>
                <table className="table table-striped table-md">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">کالا</th>
                      <th scope="col vertical-center">کد کالا</th>
                      <th scope="col vertical-center">تعداد</th>
                      <th scope="col vertical-center">قیمت واحد</th>
                      <th scope="col vertical-center">تخفیف</th>
                      <th scope="col vertical-center">مالیات</th>
                      <th scope="col vertical-center">قیمت کل (ریال)</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <td>
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </td>
                        <td>{item.productName}</td>
                        <td>{item.productCode}</td>
                        <td>{item.amount}</td>
                        <td>{methods.addNumSeperator(item.singlePrice)}</td>
                        <td>{methods.addNumSeperator(item.discount)}</td>
                        <td>{methods.addNumSeperator(item.taxPrice)}</td>
                        <td>{methods.addNumSeperator(item.finalPrice)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return <>{moduleRender()}</>;
};

export default ProductReport;
